import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import api from "../../apiConfig";
import Cookies from "js-cookie";

const SessionDataContext = createContext();

export function SessionDataProvider({ children }) {
    const [sessionData, setSessionData] = useState({
        userId: 0,
        rights: 0,
        isLogged: false,
        isUserAdmin: false,
        username: '',
        nickname: '',
        email: '',
        profileImage: '',
        siteName: 'Skrach.it',
        siteUrl: 'https://skrach.it',
        volume: Cookies.get('volume') ?? 0.5,
        votedSkraches: [],
    });

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({
        gameMode: Number(Cookies.get('gameModeId') || 1),
        selectedTags: [],
        skrach: {
            title: '',
            image: '',
            skrachId: 0,
            questions: [],
            currentQuestionId: undefined,
            time_limit: 0,
        }
    });

    const isSmallScreen = useResponsiveCheck();

    const setGameMode = (newId) => {
        const idNum = Number(newId);
        setData(prev => ({
            ...prev,
            gameMode: idNum,
        }));
        Cookies.set('gameModeId', idNum, { expires: 7 });
    };

    function useResponsiveCheck() {
        const getIsSmallScreen = () => {
            const screenWidth = window.innerWidth || document.documentElement.clientWidth;
            const screenHeight = window.innerHeight || document.documentElement.clientHeight;
            return screenWidth <= 1300 || screenHeight <= 600;
        };

        const [isSmallScreen, setIsSmallScreen] = useState(getIsSmallScreen());

        useEffect(() => {
            const handleResize = () => setIsSmallScreen(getIsSmallScreen());

            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return isSmallScreen;
    }

    useEffect(() => {
        setSessionData((prevData) => ({
            ...prevData,
            isUserAdmin: prevData.rights === 5,
            isLogged: prevData.userId !== 0,
        }));
    }, [sessionData.userId]);

    // useEffect(() => {
    //     console.log('Data: ', data);
    // }, [data]);
    //
    // useEffect(() => {
    //     console.log('SessionData: ', sessionData);
    // }, [sessionData]);

    const isOnPath = (path) => {
        return window.location.pathname === path;
    };

    const isPathStartsWith = (path) => {
        return window.location.pathname.startsWith(path);
    };

    useEffect(() => {
        getSessionData();
        getAllData();
    }, []);

    function getSessionData() {
        axios.get('/api/session/getSessionData')
            .then((result) => {
                if (result.data !== false) {
                    setSessionData((prev) => ({
                        ...prev,
                        userId: result.data.user_id,
                        rights: result.data.rights,
                        username: result.data.username,
                        nickname: result.data.nickname,
                        email: result.data.email,
                        profileImage: result.data.profile_image,
                        votedSkraches: result.data.voted_skraches,
                    }));
                    Cookies.set('user_id', result.data.user_id);
                    Cookies.set('nickname', result.data.nickname);
                    if (
                        result.data.nickname === null &&
                        result.data.user_id !== 0 &&
                        !window.location.pathname.includes('/createNickname')) {
                        window.location.href = '/createNickname';
                    }
                } else {
                    setSessionData({
                        ...sessionData,
                        userId: 0,
                        rights: 0,
                    });
                    Cookies.remove('user_id');
                    Cookies.remove('nickname');
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function getAllData() {
        api.get('/api/general/getAllData')
            .then((result) => {
                if (result.data !== false) {
                    setData((prevData) => ({
                        ...prevData,
                        ...result.data
                    }));
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function cleanCategoryTitle(title) {
        return title.replace(/[\p{Emoji_Presentation}\p{Emoji}\u200d]+/gu, '').trim();
    }

    function slugify(text) {
        return cleanCategoryTitle(text)
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '') // remove non-alphanum
            .replace(/\s+/g, '-')         // spaces to dashes
            .replace(/-+/g, '-')          // remove duplicate dashes
            .trim();
    }

    return (
        <SessionDataContext.Provider
            value={{
                sessionData,
                setSessionData,
                isOnPath,
                isPathStartsWith,
                loading,
                data,
                setData,
                setGameMode,
                isSmallScreen,
                slugify,
            }}
        >
            {children}
        </SessionDataContext.Provider>
    );
}

export function useSessionData() {
    const context = useContext(SessionDataContext);
    if (!context) {
        throw new Error('useSessionData must be used within a SessionDataProvider');
    }
    return context;
}
